module.exports = __webpack_public_path__ + "help-pitch.png";